module.exports = __webpack_public_path__ + "f4043a8f4e22cc8f78b03f9422e72309.svg";